//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from "vue";
import {required, minLength, between} from "vuelidate/lib/validators";
import DateAndTime from "@/components/appointment/DateAndTime.vue";
import DateAndTimeApi from "@/components/appointment/DateAndTimeApi.vue";
import InfoAboutSpecialist from "~/components/appointment/InfoAboutSpecialist.vue";
import {AppMixin} from "~/node_modules/sitis-nuxt/lib/mixins";
import FormSelect from "./_AppointmentModal/Select";
import {comagicAddOfflineRequest} from "~/helpers/comagic";

export default Vue.extend({
  name: "AppointmentModal",
  data() {
    return {
      workTime: {},
      specialist: [],
      appointmentForm: {
        name: "",
        phone: null,
        service: "",
        childAge: "",
        store: "",
        specialist: "",
        date: "",
        value: "",
        timeOfBeginning: "",
        timeOfEnding: "",
      },
      activeTab: 2,
      isMenuOpen: false,
      isSubmit: false,

      isPrivacyPolicy: true,
      isConsentProcessing: true,
      isAgreeReceiveInformation: true,
    };
  },
  mixins: [AppMixin],
  validations: function () {

    let appointmentForm = {
      name: {
        required,
        minLength: minLength(2),
      },
      phone: {
        required,
        minLength: minLength(15),
      },
      service: {
        required,
      },
      store: {
        required,
      },
      timeOfEnding: {
        required,
      },
    };

    if (this.activeTab === 2) {
      appointmentForm.childAge = {
        required
      };
    }

    return {
      appointmentForm
    }
  },
  computed: {
    salons() {
      const specialist = this.specialist;
      const store = specialist[0]?.stores || [];
      return store;
    },
    services() {
      const services = this.specialist[0]?.services || [];
      return services;
    },
    actvieService() {
      const activeServiceId = this.appointmentForm?.service;
      const specialist = this.specialist[0];
      if (!activeServiceId) {
        return "Выберите услугу";
      }
      return specialist.services.find(
        (service) => service.id == activeServiceId
      ).name;
    },
    actvieSalon() {
      const activeSalonId = this.appointmentForm?.store;
      const specialist = this.specialist[0];
      if (!activeSalonId) {
        return "Выберите салон";
      }
      return specialist.stores.find((store) => store.id == activeSalonId).title;
    },

    optionsAge: function () {
      const specialist = this?.specialist?.[0] || {};

      let allowableAges = specialist?.ages || {};

      let ages = [];
      if (allowableAges.for_children_2_6) {
        ages.push({label: "от 2 до 6 лет", value: "for_children_2_6"})
      }
      if (allowableAges.for_children_7_11) {
        ages.push({label: "от 7 до 11 лет", value: "for_children_7_11"})
      }
      if (allowableAges.for_children_12_18) {
        ages.push({label: "от 12 до 18 лет", value: "for_children_12_18"})
      }
      if (allowableAges.for_not_children) {
        ages.push({label: "старше 18 лет", value: "for_not_children"})
      }

      return ages
    },
    optionsServices: function () {
      const specialist = this?.specialist?.[0] || {};
      const childAge = this.appointmentForm.childAge || "";
      const services = specialist?.services || [];

      return services
        .filter((service) => {

          // Если возраст больше 18 лет
          if (childAge === "for_not_children") {
            return Boolean(
              !service.for_children_2_6 &&
              !service.for_children_7_11 &&
              !service.for_children_12_18
            )
          }

          return Boolean(
            service?.[childAge]
          )
        })
        .map((service) => {
        return {
          label: service.name,
          value: service.id
        }
      })
    },
    optionsSalons: function () {
      const specialist = this?.specialist?.[0] || {};
      const stores = specialist?.stores || [];

      return stores.map((store) => {
        return {
          label: store.title,
          value: store.id
        }
      })
    },

    isVisibleDateAndTimeApi: function () {
      return Boolean(this.appointmentForm.specialist && this.appointmentForm.store && this.appointmentForm.service)
    },
  },
  async mounted() {
    try {
      const {data} = await this.$api.agent.transport.get(`specialist?filter[id]=${this.userId}&expand=stores,services`);
      this.specialist = data;
    } catch (error) {
      this.$nuxt.error({statusCode: 404, message: 'Страница не найдена'});
      console.log(error.response);
    }
    this.$modal.show("appointment-modal");
    this.onChangeForm({
      target: {
        name: "specialist",
        value: this.specialist[0].id,
      },
    });

    window.history.replaceState(null, null, `/specialists/${this.userId}`);
  },
  methods: {
    async onSubmitForm() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        return null;
      } else {
        this.isSubmit = true;

        let ageMessage = "";
        if (this.appointmentForm.childAge === "for_children_2_6") {
          ageMessage = "Услуга для возраста: от 2 до 6 лет";
        }
        if (this.appointmentForm.childAge === "for_children_7_11") {
          ageMessage = "Услуга для возраста: от 7 до 11 лет";
        }
        if (this.appointmentForm.childAge === "for_children_12_18") {
          ageMessage = "Услуга для возраста: от 12 до 18 лет";
        }
        if (this.appointmentForm.childAge === "for_not_children") {
          ageMessage = "Услуга для возраста: старше 18 лет";
        }

        let form = {
          name: this.appointmentForm.name,
          phone: `7${this.appointmentForm.phone.replace(/\D+/g, "")}`,
          service_id: this.appointmentForm.service,
          store_id: this.appointmentForm.store,
          specialist_id: this.appointmentForm.specialist,
          date: this.$moment(this.appointmentForm.date).format("YYYY-MM-DD"),
          begin: this.appointmentForm.timeOfBeginning,
          end: this.appointmentForm.timeOfEnding,
          // age_type: this.activeTab,
          is_marketing: this.isAgreeReceiveInformation,
        };
        if (this.activeTab === 2) {
          let selectAge = (this.optionsAge || []).find((t) => t.value === this.appointmentForm.childAge)?.label;

          form = {
            ...form,
            comment: `${ ageMessage }`,
          };
        }
        try {
          const res = await this.$api.agent.transport.post("appointment", form);
          if (res) {
            this.isSubmit = false;
            this.$router.push("/zapis/success");

            await comagicAddOfflineRequest({
              name: form.name,
              phone: form.phone,
            })
          }
        } catch (error) {
          this.isSubmit = false;

          const {status} = error.response;

          if (status === 400) {
            this.$customNotification.error(
              "Запись на приём в выбранный период недоступна. Пожалуйста, укажите другое время",
              {
                duration: 6000,
              }
            );
          } else {
            this.$customNotification.error("Произошла ошибка", {
              duration: 6000,
            });
          }
        }
      }
    },
    closeModal() {
      this.$emit("closeModal");

      window.history.replaceState(null, null, `/specialists`);
    },
    setApointmentTime(appointmentTime) {
      this.appointmentForm.date = appointmentTime.day;
      this.appointmentForm.value = appointmentTime.value;
      this.appointmentForm.timeOfBeginning = appointmentTime.start;
      this.appointmentForm.timeOfEnding = appointmentTime.end;
    },
    async getWorkTime() {
      if (
        this.appointmentForm.specialist &&
        this.appointmentForm.store &&
        this.appointmentForm.service
      ) {
        try {
          const {data} = await this.$api.agent.transport.get(
            `appointment/available/${this.appointmentForm.service}/${this.appointmentForm.store}/${this.appointmentForm.specialist}`
          );

          this.workTime = data;
        } catch (error) {
          console.log(error.response);
        }
      }
    },

    onChangeForm({target}) {
      const {name, value} = target;
      const newForm = {...this.appointmentForm};
      newForm[name] = value;
      this.appointmentForm = newForm;

      ( async () => {
        await this.getWorkTime();
      })();
    },
    onChangeSelect: function ({ target }) {
      const { name, value } = target;
      let newForm = {...this.appointmentForm};

      newForm[name] = value;

      if (name === "childAge") {
        newForm.service = "";
        newForm.store = "";
      }
      if (name === "service") {
        newForm.store = "";
      }

      this.appointmentForm = newForm;

      ( async () => {
        await this.getWorkTime();
      })();
    }
  },
  components: {
    FormSelect,
    DateAndTime,
    DateAndTimeApi,
    InfoAboutSpecialist
  },
  props: {
    userId: {
      type: String,
      required: true,
    },
  },
});
